/**
 * 函数check window 一个变量是否存在，给一个最大的等待时间，如果超过这个时间还是没有这个变量，则认为是不存在的。
 * @param methodName Android的插件方法名, 支持 path 检测。
 * @param maxWaitTime 最大等待时间, 默认500毫秒
 * @returns
 */
export function awaitNtvPluginReady(): Promise<boolean> {
  // iOS不需要检测
  return Promise.resolve(true);
}
